/*
 * main-pos-handlers.js  (jQuery 3, load after pos-main-client.js)
 * What the main POS does when another device asks for something over SocketHub.main
 * (senders: sendToMainPos() in utils.js). Only the app (ReactNativeWebView) can print or open the drawer.
 *
 *   print           {orderData}              pull printing of a new order
 *   print_service   {printData}              a ready-made app message (saved table, advance receipt, test print, ...)
 *   open_drawer     {message}                open the cash drawer
 *   print_z_report  {printData, ipAddress, type}
 *   web_print       {kind, ...}              a browser without the app asks for a receipt; the reply is sent
 *                                            when the app reports it is done (resolveWebPrint)
 *
 * Also here: report.created (relay broadcast), sent when a z-report / start balance is created on
 * another device, so this device moves on to the new day.
 */
(function (window, $) {
  'use strict';

  var WEB_PRINT_TIMEOUT = 11000; // the asking browser gives up at 12 s
  var webPrints = {}; // requesting device id -> {resolve, timer}

  function toApp(message) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  }
  function noApp() {
    return !window.ReactNativeWebView;
  }

  // Called from ReactNativeMessageHandler.js when the app reports 'web_print_completed'
  window.resolveWebPrint = function (deviceId, orderIds) {
    var p = webPrints[deviceId];
    if (!p) return;
    delete webPrints[deviceId];
    clearTimeout(p.timer);
    p.resolve({ status: 'success', data: { orderIds: orderIds || [] } });
  };

  function webPrint(p, ctx) {
    var from = ctx.from;
    switch (p.kind) {
      case 'web_print_order':
        passDataToWebView(null, 'web_print_order', p.order_data, null, null, null, null, from);
        break;
      case 'advance_receipt':
      case 'supply_list':
        passDataToWebView(
          null,
          p.kind,
          p.orderProducts,
          p.ipAddress,
          p.printerType,
          p.organizer,
          null,
          from,
          p.tableNumber,
          p.tableCustomerName
        );
        break;
      default:
        return { status: 'rejected', reason: 'bad_request' };
    }

    return new Promise(function (resolve) {
      if (webPrints[from]) {
        clearTimeout(webPrints[from].timer);
        webPrints[from].resolve({ status: 'failed', reason: 'superseded' });
      }
      webPrints[from] = {
        resolve: resolve,
        timer: setTimeout(function () {
          delete webPrints[from];
          resolve({ status: 'failed', reason: 'print_timeout' });
        }, WEB_PRINT_TIMEOUT),
      };
    });
  }

  function reportCreated(data) {
    if (!data) return;
    var stored = localStorage.getItem(data.organizer_id + '_mainLocationId');
    if (stored != data.location_id) return;

    $.ajax({ url: '/api/v1/check-login', method: 'GET', dataType: 'json' })
      .done(function (res) {
        if (!(res && res.isLoggedIn && res.mainLocationId == data.location_id)) {
          return;
        }
        if ($('body').attr('p') === 'starting_cash_balance') {
          window.location.reload();
          return;
        }
        if (res.redirect_url && $('body').attr('p') !== 'payment_standby_mode') {
          window.location.href = res.redirect_url;
        }
      })
      .fail(function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.redirect_url) {
          document.location.href = xhr.responseJSON.redirect_url;
        }
      });
  }

  $(function () {
    var T = window.SocketHub;
    if (!T) return;

    if (T.relay) T.relay.on('report.created', reportCreated);

    if (!T.main) return;
    T.main.handle('print', function (p) {
      if (noApp()) return { status: 'rejected', reason: 'no_webview' };
      if (!p || !p.orderData) return { status: 'rejected', reason: 'bad_request' };
      passDataToWebView(null, 'print_poll_order', p.orderData);
    });

    T.main.handle('print_service', function (p) {
      if (noApp()) return { status: 'rejected', reason: 'no_webview' };
      if (!p || !p.printData) return { status: 'rejected', reason: 'bad_request' };
      toApp(p.printData);
    });

    T.main.handle('open_drawer', function (p) {
      if (noApp()) return { status: 'rejected', reason: 'no_webview' };
      if (!p || !p.message) return { status: 'rejected', reason: 'bad_request' };
      toApp(p.message);
    });

    T.main.handle('print_z_report', function (p) {
      if (noApp()) return { status: 'rejected', reason: 'no_webview' };
      if (!p || !p.printData) return { status: 'rejected', reason: 'bad_request' };
      passDataToWebView(null, 'print_z_report', p.printData, p.ipAddress, p.type);
    });

    T.main.handle('web_print', function (p, ctx) {
      if (noApp()) return { status: 'rejected', reason: 'no_webview' };
      if (!p) return { status: 'rejected', reason: 'bad_request' };
      return webPrint(p, ctx);
    });
  });
})(window, jQuery);
